<template>
    <Main>
        <div slot="main" class="main user">
            <div class="bank_title">
                <Header :data='headerInfo'></Header>
            </div>
            <div class="content">
                <div class="l">
                    <div class="tab">
                        <div class="tab_item active_item">
                            <img src="../../assets/data_icon_001.png" alt="">
                            <div>
                                <span>{{dataTotalInfo.farmer|| 0}}</span>
                                <label>养殖户(家)</label>
                            </div>
                        </div>
                        <div class="tab_item">
                            <img src="../../assets/data_icon_001.png" alt="">
                            <div>
                                <span>{{dataTotalInfo.technical || 0}}</span>
                                <label>畜牧科技师(人)</label>
                            </div>
                        </div>
                        <div class="tab_item">
                            <img src="../../assets/data_icon_001.png" alt="">
                            <div>
                                <span>{{dataTotalInfo.areaPartner || 0}}</span>
                                <label>区域合伙人(人)</label>
                            </div>
                        </div>
                    </div>
                    <div class="subtitle">
                        <div class="subtitle_txt">
                            养殖户地域分布
                        </div>
                    </div>
                    <div class="map_main">
                        <div id="mapBox" class="map_box"></div>
                    </div>
                </div>
                <div class="c">
                    <div class="subtitle m_t_sm">
                        <div class="subtitle_txt">
                            养殖户增长趋势
                        </div>
                        <div class="tab_box">
                            <div class="tab_item" :class="{active: currentTimeStatus === 'oneMonth'}"
                                @click="changeTime('oneMonth')">近1月</div>
                            <div class="tab_item" :class="{active: currentTimeStatus === 'threeMonth'}"
                                @click="changeTime('threeMonth')">近3月</div>
                            <div class="tab_item" :class="{active: currentTimeStatus === 'sixMonth'}"
                                @click="changeTime('sixMonth')">近6月</div>
                            <div v-if="windowWidth >= 1920" class="tab_item"
                                :class="{active: currentTimeStatus === 'thisYear'}" @click="changeTime('thisYear')">近1年
                            </div>
                        </div>
                    </div>
                    <div class="total_data">
                        <div class="total_data_item">
                            <img src="../../assets/data_icon_001.png" alt="">
                            <div>
                                <label>累计新增</label>
                                <div class="num">
                                    <span>{{currentTimeData.newlyIncrease}}</span>
                                    <div class="ratio" :class="{ratio_up: currentTimeData.flag == 0 }">
                                        <label>环比</label>
                                        <span>{{currentTimeData.linkRelativeRadio}}</span>
                                        <img v-if="currentTimeData.flag == 1 " src="../../assets/down_icon.png" alt="">
                                        <img v-else src="../../assets/up_icon.png" alt="">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="lineChart" class="line_chart"></div>
                    <div class="subtitle m_t_sm">
                        <div class="subtitle_txt">
                            养殖户类型分布
                        </div>
                    </div>
                    <div id="rangChart1" class="rang_chart"></div>
                    <div class="subtitle m_t_sm1">
                        <div class="subtitle_txt">
                            养殖活畜品类分布
                        </div>
                    </div>
                    <div id="rangChart2" class="rang_chart"></div>
                </div>
                <div class="r">
                    <div class="subtitle m_t_sm">
                        <div class="subtitle_txt">
                            养殖户查询
                        </div>
                    </div>
                    <div class="sreach">
                        <div class="sreach_row">
                            <el-input style="flex: 1; height: 0.31rem; font-size:0.13rem" v-model="userName"
                                placeholder="输入养殖户名称/畜牧科技师姓名检索"></el-input>
                            <div class="btn btn_min_w m_r_sm" @click="getList">搜索</div>
                            <div class="btn reset_btn" @click="reset"><i class="el-icon-refresh-right"></i></div>
                        </div>
                        <div class="sreach_row">
                            <el-cascader placeholder="所在地址"
                                style="flex: 1;height: 0.31rem;margin-right: 0.1rem; font-size:0.13rem"
                                v-model="address" :options="baseArea">
                            </el-cascader>
                            <el-select v-model="userType" placeholder="养殖户类型"
                                style="flex: 1;height: 0.31rem; font-size:0.13rem">
                                <el-option v-for="item in userTypeList" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </div>

                    </div>
                    <!-- <div class="user_list">
                        <div class="user_item" v-for="(item, index) in dataList" :key="index" @click="info(item)">
                            <div class="user_info">
                                <div class="user_img">
                                    <img src="../../assets/header_default_img.png" alt="">
                                </div>
                                <div>
                                    <div class="user_name">
                                        {{item.name}}
                                        <label :class="{
                                            bg3: item.farmer_code == 0,
                                            bg1: item.farmer_code == 1,
                                            bg2: item.farmer_code == 2,
                                            bg4: item.farmer_code == 3,
                                        }">{{item.farmerType}}</label>
                                    </div>
                                    <p>地址：{{item.address}}</p>
                                    <p>
                                        <span>所属畜牧科技师：{{item.rearLivestock}}</span>
                                        <span>养殖活畜(头)：{{item.breedingNum}}</span>
                                    </p>
                                </div>
                            </div>
                            <i class="arrow_right el-icon-arrow-right"></i>
                        </div>
                    </div> -->
                    <div class="user_list">
                        <div class="user_item" v-for="(item, index) in breederList" :key="index" @click="info(item)">
                            <div class="user_info">
                                <div class="user_img">
                                    <img src="../../assets/header_default_img.png" alt="">
                                </div>
                                <div>
                                    <div class="user_name">
                                        {{item.farmerName}}
                                        <label :class="{
                                            bg3: item.farmerTypeCode == 0,
                                            bg1: item.farmerTypeCode == 1,
                                            bg2: item.farmerTypeCode == 2,
                                            bg4: item.farmerTypeCode == 3,
                                        }">{{item.farmerType}}</label>
                                    </div>
                                    <p>地址：{{item.address}}</p>
                                    <p>
                                        <span>所属畜牧科技师：{{item.rearLiveStock}}</span>
                                        <span>养殖活畜(头)：{{item.breedingNum}}</span>
                                    </p>
                                </div>
                            </div>
                            <i class="arrow_right el-icon-arrow-right"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Main>
</template>

<script>
import Main from "@/components/main.vue";
import Header from "../../components/header.vue";
import HighCharts from 'highcharts'
import Highcharts3D from 'highcharts/highcharts-3d';
import cityJson from "@/assets/js/city.js";
Highcharts3D(HighCharts);
export default {
    components: {
        Main,
        Header,
    },
    data() {
        return {
            headerInfo: {},
            userInfo: {},
            dataInfo: {},
            currentSelect: '',
            optionData: [],
            currentTimeStatus: 'oneMonth',
            currentTimeData: {},
            userTypeList: [
                { value: '0', label: '大型养殖场' },
                { value: '1', label: '个体养殖户' },
                { value: '2', label: '专业养殖户' },
                { value: '3', label: '小型养殖场' },
            ],
            address: [],
            userType: '',
            userName: '',
            dataList: [],
            lineDataAll: [],
            farmerGrowTrend: {},
            dataTotalInfo: {},
            baseArea: cityJson,
            windowWidth: window.screen.width,
            // 养殖户列表
            breederList: []
        };
    },
    created() {
        this.headerInfo = {
            name: window.localStorage.getItem('screenName')
        }
        this.userInfo = JSON.parse(window.localStorage.getItem('NMYDATAUSERINFO'))
        // 获取养殖户列表
        this.getBreederList()
        this.getMap()
        // this.getList()
        this.getTotal()
    },
    mounted() {
    },
    methods: {
        // 获取养殖户列表
        getBreederList() {
            let countId = ''
            if (this.address.length > 0) {
                countId = this.address[1]
            }
            this.$http({
                url: 'screenapp-service/baseScreenFarmer/farmerList',
                //请求方式
                method: 'post',
                //传递的参数
                data: {
                    deptId: this.userInfo.dept.deptId,
                    countId: countId,
                    name: this.userName,
                    farmerTypeCode: this.userType,
                },
            }).then(res => {
                this.breederList = res.data.result
                // console.log(res.data.result, 'res');
            })
        },
        getData() {
            this.$http({
                url: 'screenapp-service/baseBigScreen/select/other',
                //请求方式
                method: 'post',
                //传递的参数
                data: {
                    "parentId": "4",
                    "menuMark": "3",
                    "dataFlag": "0",
                    deptId: this.userInfo.dept.deptId,
                },
            }).then(res => {
                const data = res.data;
                if (res.data.code === 200) {
                    const screenData = JSON.parse(data.result.screenData)
                    this.dataInfo = screenData
                    this.farmerGrowTrend = this.dataInfo.farmerGrowTrend
                    this.lineDataAll = this.dataInfo.farmerGrowTrend.dataMap
                    this.dataInfo.farmerKindDis.map(item => {
                        item.value = +item.proportion;
                        item.name = item.title
                        return item
                    })
                    this.dataInfo.farmLiveAnimalDis.map(item => {
                        item.value = +item.proportion;
                        item.name = item.title
                        return item
                    })
                    this.infoLineData()
                    console.log(screenData)
                    this.$nextTick(() => {
                        // this.setLineData(this.dataInfo.tradePrice, 'lineChart3')
                        this.rangChart({
                            dom: 'rangChart1',
                            data: this.dataInfo.farmerKindDis
                        })
                        this.rangChart({
                            dom: 'rangChart2',
                            data: this.dataInfo.farmLiveAnimalDis
                        })
                        this.dataInfo.farmerAreaDis.forEach(item => {
                            item.name = item.city
                        })
                        this.draw(this.region, this.dataInfo.farmerAreaDis)
                    })
                } else {
                    this.$message.error(data);
                }
            })
        },
        reset() {
            this.address = '';
            this.userType = '';
            this.userName = '';
            this.getList()
        },
        getList() {
            // 获取养殖户列表
            this.getBreederList()
            // let countId = ''
            // if (this.address.length > 0) {
            //     countId = this.address[1]
            // }
            // this.$http({
            //     url: 'screenapp-service/baseBigScreen/select/farmer',
            //     //请求方式
            //     method: 'post',
            //     //传递的参数
            //     data: {
            //         "parentId": "4",
            //         "menuMark": "3",
            //         "dataFlag": "1",
            //         deptId: this.userInfo.dept.deptId,
            //         countId: countId,
            //         farmerTypeCode: this.userType,
            //         name: this.userName,
            //     },
            // }).then(res => {
            //     const data = res.data;
            //     if (res.data.code === 200) {
            //         const screenData = JSON.parse(data.result.screenData)
            //         console.log(screenData, 23456);
            //         console.log(screenData)
            //         this.dataList = screenData.farmerList.value
            //     } else {
            //         this.$message.error(data);
            //     }
            // })
        },
        getTotal() {
            this.$http({
                url: 'screenapp-service/baseBigScreen/select',
                //请求方式
                method: 'post',
                //传递的参数
                data: {
                    "parentId": "0",
                    "menuMark": "4",
                    deptId: this.userInfo.dept.deptId,
                },
            }).then(res => {
                const data = res.data;
                if (res.data.code === 200) {
                    const screenData = JSON.parse(data.result.screenData)
                    this.dataTotalInfo = screenData.panel
                } else {
                    this.$message.error(data);
                }
            })
        },
        getMap() {
            this.$http({
                url: 'screenapp-service/baseScreenEnterpriseInfo/select/mapData',
                //请求方式
                method: 'post',
                //传递的参数
                data: {
                    deptId: this.userInfo.dept.deptId,
                },
            }).then(res => {
                if (res.data.code === 200) {
                    this.region = res.data.result.json;
                    this.getData()
                }
            })
        },
        info(item) {
            window.localStorage.setItem('userInfoItem', JSON.stringify(item))
            this.$router.push({
                name: 'userInfo'
            })
        },
        infoLineData() {
            this.currentTimeData = this.lineDataAll[this.currentTimeStatus]
            console.log(this.currentTimeData, 'currentTimeData')
            this.setLineData([
                this.currentTimeData
            ], 'lineChart')
        },
        changeTime(status) {
            this.currentTimeStatus = status
            this.infoLineData()
        },
        draw(geoJson, data) {
            // 基于准备好的dom，初始化echarts实例
            var chart = this.$echarts.init(document.getElementById("mapBox"));
            geoJson.features.forEach((item) => {
                item['properties']['cp'] = item.properties.center
            })
            this.$echarts.registerMap("bayannaoer", geoJson);
            // 隐藏动画加载效果。
            chart.hideLoading();
            chart.setOption({
                tooltip: {
                    // 提示框
                    trigger: "item",
                    // borderColor: "rgba(33,80,231,1)",
                    // borderWidth: 2,
                    // backgroundColor: "rgba(7, 70, 73, 0.79)",
                    backgroundColor: 'rgba(255,255,255,0.8)',
                    borderColor: '#292929',
                    borderWidth: 1,
                    textStyle: {
                        color: '#050F37',
                    },
                    padding: 5,
                    extraCssText: "box-shadow: rgba(47, 244, 225, 0.5) 0px 0px 10px;",
                    formatter: function (params) {
                        return `<p>
                            <span style="font-size: 14px; font-weight: normal;">${params.name
                            }：${params.data.account || 0}个</span>
                            
                        </p>`;
                    },
                },
                series: [
                    {
                        type: "map", // 系列类型
                        name: "map", // 系列名称
                        zoom: 1.2,
                        map: "bayannaoer", // 地图类型。echarts-gl 中使用的地图类型同 geo 组件相同(ECharts 中提供了两种格式的地图数据，一种是可以直接 script 标签引入的 js 文件，引入后会自动注册地图名字和数据。还有一种是 JSON 文件，需要通过 AJAX 异步加载后手动注册。)
                        data: data,
                        // label: {
                        //     // 标签的相关设置
                        //     // show: true, // (地图上的城市名称)是否显示标签 [ default: false ]
                        //     // distance: 0, // 标签距离图形的距离，在三维的散点图中这个距离是屏幕空间的像素值，其它图中这个距离是相对的三维距离 标签内容格式器

                        //     //     position: 'inside',
                        //     // textStyle: {
                        //     //     // 标签的字体样式
                        //     //     color: "#000", // 地图初始化区域字体颜色
                        //     //     fontSize: 8, // 字体大小
                        //     //     opacity: 1, // 字体透明度
                        //     //     backgroundColor: "rgba(0,23,11,0)", // 字体背景色
                        //     // },

                        //     normal: {
                        //         show: false,
                        //         color: 'rgba(5, 176, 220, 1)',
                        //         fontSize: 1, //此处字体需做兼容适配

                        //         align: 'left',
                        //         verticalAlign: 'middle',
                        //         position: 'inside',
                        //         distance: 15,
                        //     },
                        //     emphasis: {
                        //         show: false,
                        //         color: '#ececec'
                        //     }
                        // },
                        label: {
                            // properties.cp
                            // 标签的相关设置
                            show: true, // (地图上的城市名称)是否显示标签 [ default: false ]
                            // distance: 10, // 标签距离图形的距离，在三维的散点图中这个距离是屏幕空间的像素值，其它图中这个距离是相对的三维距离 标签内容格式器
                            position: 'top',
                            // offset: [-10, 5],
                            textStyle: {
                                // 标签的字体样式
                                color: "white", // 地图初始化区域字体颜色
                                fontSize: 8, // 字体大小
                                opacity: 1, // 字体透明度
                                backgroundColor: "rgba(0,23,11,0)", // 字体背景色
                            },
                            // align: 'center',
                            // verticalAlign: 'middle'
                            // normal: {
                            //     show: true,
                            //     color: 'rgba(5, 176, 220, 1)',
                            //     fontSize: 1, //此处字体需做兼容适配

                            //     align: 'left',
                            //     verticalAlign: 'middle',
                            //     position: 'inside',
                            //     distance: 15,
                            // },
                            // emphasis: {
                            //     show: true,
                            //     color: '#ececec'
                            // }
                        },
                        itemStyle: {
                            // 三维地理坐标系组件 中三维图形的视觉属性，包括颜色，透明度，描边等。
                            color: "rgba(33,80,231,1)", // 地图板块的颜色
                            opacity: 1, // 图形的不透明度 [ default: 1 ]
                            borderWidth: 1, // (地图板块间的分隔线)图形描边的宽度。加上描边后可以更清晰的区分每个区域 [ default: 0 ]
                            borderColor: "#37C1FD", // 图形描边的颜色。[ default: #333 ]
                            normal: { // 默认地图区域样式
                                areaColor: 'rgba(33,80,231,1)',
                                borderColor: "#4ECEE6",
                                borderWidth: 1,
                                shadowColor: "#2C99F6",
                                shadowOffsetY: 0,
                                shadowBlur: 25,
                            },
                        },

                        emphasis: {
                            // 鼠标 hover 高亮时图形和标签的样式 (当鼠标放上去时 label和itemStyle 的样式)
                            label: {
                                // label高亮时的配置
                                show: true,
                                textStyle: {
                                    color: "#fff", // 高亮时标签颜色变为 白色
                                    fontSize: 15, // 高亮时标签字体 变大
                                },
                                // formatter : function(params) {
                                //     console.log(params)
                                // }
                            },
                            itemStyle: {
                                "areaColor": "#1E88E5"
                            }
                        }
                    },
                ],
            });
        },
        setLineData(data, dom) {
            const colors = ['#106BDC', '#0EDAE2', '#5931FC'];
            const series = [];
            let xAxis = [];
            data.forEach((item, index) => {
                xAxis = item.label
                series.push({
                    name: item.title,
                    type: "line",
                    lineStyle: {
                        width: 2,
                    },
                    color: colors[index],
                    data: item.value,
                })
            })
            const line = {
                dom,
                xAxis,
                series: series
            }
            this.lineChart(line)
        },
        lineChart(data) {
            this.chart = this.$echarts.init(document.getElementById(data.dom))
            // 隐藏动画加载效果。
            this.chart.setOption({
                color: ['#106BDC', '#0EDAE2', '#5931FC'],
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow',
                    },
                    // backgroundColor: 'rgba(11, 15, 56, 1)',
                    // borderColor: 'rgba(18, 36, 132, 1)',
                    // borderWidth: 2,
                    // textStyle: {
                    //     color: '#fff',
                    // },
                    backgroundColor: 'rgba(255,255,255,0.8)',
                    borderColor: '#292929',
                    borderWidth: 1,
                    textStyle: {
                        color: '#050F37',
                    },

                },
                legend: data.legend,
                grid: {
                    top: '25%',
                    left: '3%',
                    right: '4%',
                    bottom: '10%',
                    containLabel: true,
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: true,
                    axisLabel: {
                        color: '#6FB6FF',
                    },
                    axisLine: {
                        show: true, // X轴 网格线 颜色类型的修改
                        lineStyle: {
                            color: '#11296D',
                        },
                    },
                    axisTick: {
                        // X轴线 刻度线
                        show: false,
                    },
                    data: data.xAxis,
                },
                yAxis: {
                    name: '金额(万)',
                    nameTextStyle: {
                        color: '#6FB6FF',
                        padding: [3, 4],
                    },
                    splitLine: false,
                    type: 'value',
                    axisLine: {
                        show: false, // Y轴线
                        lineStyle: {
                            color: 'rgba(85, 193, 255, 1)',
                        },
                    },
                    axisLabel: {
                        color: '#6FB6FF',
                    },
                },
                series: data.series,
            })
        },
        rangChart(data) {
            var myChart = this.$echarts.init(document.getElementById(data.dom));
            var option = {
                color: ['#0EDAE2', '#5D2CFE', '#E7C660', '#2C76FE'],
                grid: {
                    left: '10%',
                    height: '60px',
                },
                tooltip: {
                    trigger: 'item',
                    backgroundColor: 'rgba(255,255,255,0.8)',
                    borderColor: '#292929',
                    borderWidth: 1,
                    textStyle: {
                        color: '#050F37',
                    },
                },
                series: [
                    {
                        type: 'pie',
                        radius: ['40%', '70%'],
                        // avoidLabelOverlap: false,
                        label: {
                            show: true,
                            position: 'outside',
                            color: '#6FB6FF',
                            formatter: ' {b} {d}% \n\n',
                            padding: [0, -90],
                            alignTo: 'labelLine'
                        },
                        labelLine: {
                            show: true,
                            length: 5,
                            length2: 100,
                            lineStyle: {
                                color: '#73c0de',
                            }
                        },
                        data: data.data
                    }
                ]
            };
            myChart.setOption(option)
        },
    }
}
</script>

<style lang="scss" scoped>
.content {
    margin-top: 0.2rem;
    padding: 0 0.24rem;
    display: flex;

    .l {
        width: 10.54rem;
        height: 12.06rem;
        background-image: url("../../assets/bg_010.png");
        background-size: 100% 100%;

        .tab {
            display: flex;
            justify-content: space-between;
            padding: 0 0.5rem;
            margin-top: 0.74rem;

            .tab_item {
                width: 2.75rem;
                height: 1.31rem;
                background-image: url("../../assets/bg_012.png");
                background-size: 100% 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                margin-bottom: 0.55rem;
                cursor: pointer;

                img {
                    width: 0.68rem;
                    height: 0.67rem;
                    margin-right: 0.26rem;
                }

                div {
                    display: flex;
                    flex-direction: column;

                    label {
                        font-size: 0.18rem;
                        font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
                        font-weight: 400;
                        color: #FFFFFF;
                        margin-top: 0.2 rem;
                    }

                    span {
                        font-size: 0.38rem;
                        font-family: HarmonyOS Sans SC-Bold, HarmonyOS Sans SC;
                        font-weight: bold;
                        color: #FFFFFF;
                    }
                }
            }

            .active_item {
                background-image: url("../../assets/bg_011.png");

                div>span {
                    color: #FFC300;
                }
            }
        }

        .map_main {
            display: flex;
            justify-content: center
        }

        .map_box {
            width: 9.81rem;
            height: 8rem;
            padding-left: 0.2rem;
        }
    }

    .c {
        width: 6.26rem;
        height: 12.08rem;
        background-image: url("../../assets/bg_013.png");
        background-size: 100% 100%;
        margin-left: 0.25rem;

        .line_chart {
            width: 5.6rem;
            height: 2.4rem;
            margin-top: 0.2rem;
            margin-left: 0.25rem;
        }

        .rang_chart {
            width: 5.6rem;
            height: 2.8rem;
            margin-left: 0.25rem;
            margin-top: 0.35rem;
        }
    }

    .r {
        width: 6.26rem;
        height: 12.08rem;
        background-image: url("../../assets/bg_013.png");
        background-size: 100% 100%;
        margin-left: 0.25rem;

        .sreach {
            padding: 0 0.2rem;

            .sreach_row {
                display: flex;
                align-items: center;
                box-sizing: border-box;
                margin-bottom: 0.2rem;
            }

            .btn {
                width: 0.45rem;
                height: 0.31rem;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 0.13rem;
                font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
                font-weight: 400;
                color: #FFFFFF;
                background: #2C75FD;
                cursor: pointer;
            }

            .reset_btn {
                width: 0.31rem;
            }

            .btn_min_w {
                min-width: 0.45rem;
            }

            .m_r_sm {
                margin-right: 0.1rem;
            }
        }

        .user_list {
            width: 100%;
            height: 9.83rem;
            overflow-y: scroll;
            padding: 0 0.23rem;

            /* 设置滚动条的样式 */
            ::-webkit-scrollbar {
                width: 0.1rem;
                /*滚动条粗细*/
            }

            /* 滚动槽 */
            ::-webkit-scrollbar-track {
                -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.3);
                // border-radius: 10px;
                background: rgba(28, 71, 163, 0.2);
            }

            /* 滚动条滑块 */
            ::-webkit-scrollbar-thumb {
                // border-radius: 10px;
                background: #2C76FE;
                -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.5);
            }

            .user_item {
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 0.16rem 0.25rem;
                // height: 1rem;
                background: rgba(44, 117, 253, 0.06);
                margin-bottom: 0.2rem;
                cursor: pointer;

                img {
                    width: 0.63rem;
                    height: 0.63rem;
                    margin-right: 0.2rem;
                }

                .user_info {
                    display: flex;
                    align-items: center;

                    .user_name {
                        display: flex;
                        align-items: center;
                        font-size: 0.2rem;
                        font-family: HarmonyOS Sans SC-Bold, HarmonyOS Sans SC;
                        font-weight: bold;
                        color: #FFFFFF;

                        label {
                            font-size: 0.12rem;
                            padding: 0.01rem 0.06rem;
                            margin-left: 0.1rem;
                            line-height: 0.18rem;
                        }

                        .bg1 {
                            background: #2C75FD;
                        }

                        .bg2 {
                            background: #4927D2;
                        }

                        .bg3 {
                            background: #07B9B9;
                        }

                        .bg4 {
                            background: #AE59E8;
                        }
                    }

                    p {
                        margin-top: 0.14rem;
                        font-size: 0.15rem;
                        font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
                        font-weight: 400;
                        color: rgba(255, 255, 255, 0.5);

                        span:nth-child(1) {
                            display: inline-block;
                            margin-right: 0.7rem;
                        }
                    }
                }

                .arrow_right {
                    font-size: 0.3rem;
                    color: #FFFFFF;
                }
            }
        }
    }

    // background-image: url("../../assets/bg_006.png");
    // background-size: 100% 100%;

    .subtitle {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 0.24rem;
        margin: 0.19rem;
        margin-top: 0.36rem;

        .subtitle_txt {
            width: 3rem;
            height: 0.38rem;
            line-height: 0.38rem;
            padding-left: 0.23rem;
            font-size: 0.2rem;
            font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
            font-weight: 400;
            color: #FAFAFA;
            background-image: url("../../assets/title_bg_001.png");
            background-size: 100% 100%;
        }

        .tab_box {
            display: flex;

            .tab_item {
                font-size: 0.12rem;
                font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
                font-weight: 400;
                color: #FFFFFF;
                background: rgba(255, 255, 255, 0.0902);
                padding: 0.05rem 0.08rem;
                box-sizing: border-box;
                margin: 0.06rem;
                cursor: pointer;
            }

            .active {
                background: #286AE7;
            }
        }

        .el-dropdown-link {
            background: rgba(255, 255, 255, 0.0902);
            padding: 0.05rem 0.19rem;
            font-weight: 400;
            color: rgba(255, 255, 255, 0.6);
        }
    }

    .m_t_sm1 {
        margin-top: 0.2rem;
    }

    .total_data {
        display: flex;
        margin-top: 0.3rem;

        .total_data_item {
            display: flex;
            margin-left: 0.39rem;
            flex: 1;

            img {
                width: 0.68rem;
                height: 0.67rem;
            }

            div {
                display: flex;
                flex-direction: column;
                margin-left: 0.2rem;

                label {
                    font-size: 0.18rem;
                    font-weight: 400;
                    color: #D8DFFE;
                }

                span {
                    font-size: 0.43rem;
                    font-family: HarmonyOS Sans SC-Bold, HarmonyOS Sans SC;
                    font-weight: bold;
                    color: #FFBB00;
                    margin-top: 0.2rem;
                }

                .num {
                    display: flex;
                    flex-direction: row;
                    margin: 0;

                    .ratio {
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        color: #00FFFF;
                        margin-top: 0.16rem;
                        margin-left: 0.4rem;

                        label {
                            font-size: 0.18rem;
                            color: #00FFFF;
                        }

                        span {
                            font-size: 0.18rem;
                            margin: 0 0.1rem;
                        }

                        img {
                            width: 0.3rem;
                            height: 0.3rem;
                        }
                    }

                    .ratio_up {
                        color: #FFBB00;

                        label {
                            font-size: 0.18rem;
                            color: #FFBB00;
                        }
                    }
                }
            }
        }
    }
}
</style>